import { render, staticRenderFns } from "./OpportunityPage.vue?vue&type=template&id=1dc2df7e&scoped=true&"
import script from "./OpportunityPage.vue?vue&type=script&lang=js&"
export * from "./OpportunityPage.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityPage.vue?vue&type=style&index=0&id=1dc2df7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2df7e",
  null
  
)

export default component.exports